import { defineComponent as _defineComponent } from 'vue'
import { computed, useFacetsStore } from '#imports'


export default /*#__PURE__*/_defineComponent({
  __name: 'PopularFeatures',
  setup(__props) {

const POPULAR_FEATURES_SLUGS = [
  'electric',
  'beaches',
  'hot-tub',
  'campfires-allowed',
  'bar-or-club-house',
  'adults-only',
  'pitchtype-fully-serviced',
  'wild-camping',
  'dogs-allowed',
  'outdoor-swimming-pool',
  'pub-campsite',
  'play-area',
  'camping-pods',
  'open-all-year',
]

const facetsStore = useFacetsStore()
const popularFeaturesData = computed(() => {
  return POPULAR_FEATURES_SLUGS.map((slug) => facetsStore.facetsBySlug(slug))
    .filter((facet) => facet)
    .map((facet) => ({
      name: facet.name,
      to: {
        facet: facet.slug,
        category: facet.slug === 'hot-tub' ? 'glamping' : 'campsites',
      },
      imgUrl: require(`@/assets/homepage/features/${facet.slug}.jpg`),
    }))
})

return { __sfc: true,POPULAR_FEATURES_SLUGS, facetsStore, popularFeaturesData }
}

})